import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {Card, CardBody,Modal,ModalHeader,Button,Label,Input} from "reactstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Table from 'react-bootstrap/Table';
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { v4 as uuidv4 } from 'uuid';
import Axios from 'axios'
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import 'jspdf-autotable';

export default function Upcomingrenewals() {
const [agent, setAgent] = useState('')
const [agentCode, setAgentcode] = useState('')
const [renewals, setRenewals] = useState([])
 const [currentPage, setCurrentPage] = useState(1);
const rowsPerPage = 20;
const totalPages = Math.ceil(renewals.length / rowsPerPage);
const indexOfLastRow = currentPage * rowsPerPage;
const indexOfFirstRow = indexOfLastRow - rowsPerPage;
const currentPolicies = renewals.slice(indexOfFirstRow, indexOfLastRow)
const[end,setEnd] = useState('');
const[start,setStart] = useState('');
  const [credentials, setCredentials] = useState(null)
  const [isAuth, setIsauth] = useState(false)
  const company = 'Definite'

  useEffect(()=>{
  const getCredentials =async()=>{
    const res = await fetch(`https://digitalapi.definiteassurance.com/api/getCredentials?username=${company}`)
    const data = await res.json();
    const {Username, Password} = data;
    const cred = btoa(`${Username}:${Password}`)
    setCredentials(btoa(`${Username}:${Password}`))
    setIsauth(true)


  }
  getCredentials()

  },[])

    const exportTableToPDF = () => {
        const input = document.getElementById('policy-table');
        
        // Optional: Add a temporary title to the table before capturing
        const title = document.createElement('h2');
        title.textContent = `Upcoming Renewals`;
        title.style.textAlign = 'center';
        title.style.color = '#2c3e50';

        title.style.marginBottom = '20px';
        input.parentNode.insertBefore(title, input); // Insert title above table
        
        // Color the header row (if not already styled)
        const headerRow = input.querySelector('thead tr');
        headerRow.style.backgroundColor = 'green'; // Dark gray
        headerRow.style.color = 'white';
        
        html2canvas(input, {
            scale: 2, // Higher quality
            logging: false, // Disable console logs
            useCORS: true, // Handle external resources
            allowTaint: true, // Allow external images
        }).then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF('p', 'mm', 'a4');
            
            // Margins (10mm on all sides)
            const margin = 10;
            const imgWidth = 210 - margin * 2; // A4 width minus margins
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            
            // Add title text directly to PDF (alternative approach)
            pdf.setFontSize(19);
            pdf.setTextColor(44, 62, 80); // #2c3e50
            pdf.text(`Upcoming Renewals`, 105, margin, { align: 'center' }); // Centered
            
            // Add table image with margins
            pdf.addImage(
            imgData, 
            'PNG', 
            margin, 
            margin + 10, // Extra space below title
            imgWidth, 
            imgHeight
            );
        
            pdf.save('upcoming_renewals.pdf');
            
            // Clean up: Remove temporary title and header styling
            title.remove();
            headerRow.style.backgroundColor = '';
            headerRow.style.color = '';
        });
        };

useEffect(() => {

const user = localStorage.getItem('definiteagent'); // Retrieve email
if (user) {
    
    setAgent(user)
} else {

}
}, []);

useEffect(()=>{
    const getAgentcode =async()=>{
        const res =await fetch(`https://digitalapi.definiteassurance.com/api/getDealerdetails?email=${agent}`,{
              method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
        });
        const data = await res.json();
        setAgentcode(data.OID)   

    }
    if(agent && isAuth){
        getAgentcode()
    }
},[agent,isAuth])


useEffect(()=>{
    const getRenewals =async()=>{
        const res = await fetch(`https://digitalapi.definiteassurance.com/api/getUpcomingrenewals?agent=${agentCode}`,{
              method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
        })
        const data = await res.json();
        setRenewals(data)
    }

    if(agentCode && isAuth){
        getRenewals()
    }

},[agentCode,isAuth])

function formateDateISO(input){
    if(typeof input === 'string'){
        return input.split('T')[0]
    }
    else if (input instanceof Date){
        return input.toISOString().split('T')[0]
    }

    throw new Error('Invalid input: Expected ISO String or Date Object')
}

function formatDateToMilliseconds(input) {
    if (typeof input === 'string') {
        // For ISO string, create Date object and get time
        return new Date(input).getTime();
    }
    else if (input instanceof Date) {
        // For Date object, directly get time
        return input.getTime();
    }
    
    throw new Error('Invalid input: Expected ISO String or Date Object');
}

const handleDateChange = (e) => {
    const dateTime = e.target.value;
    const millisecondsSinceEpoch = new Date(dateTime).getTime();
    setStart(millisecondsSinceEpoch);

  };
  const handleDateChange2 = (e) => {
    const dateTime = e.target.value;
    const millisecondsSinceEpoch = new Date(dateTime).getTime();
    setEnd(millisecondsSinceEpoch);
   
  };

  return (
    <div>
    <div className="page-content">
        <ToastContainer />
    <Breadcrumbs title="Definite Assurance" breadcrumbItem={`UPCOMING RENEWALS`} />
    <Card className="mini-stats-wid">
        <CardBody>
            <div className="table-responsive" style={{padding:'10px'}}>
            <button 
            onClick={exportTableToPDF}
            style={{ 
                padding: '8px 16px',
                background: 'rgb(0, 96, 66)',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
            }}
            >
            Export to PDF
            </button>
            <hr />
            <hr />
            <div className="flt">
            <div className="mb-4" id='mb'>
                <Label className="form-label">From date</Label>
                <Input
                    name="text"
                    className="form-control"
                    placeholder="Search order"
                    type="datetime-local"
                    onChange={handleDateChange}
                    // value={email}

                />
                
            </div>
            <div className="mb-4" id='mb'>
                <Label className="form-label">To date</Label>
                <Input
                    name="text"
                    className="form-control"
                    placeholder="Search order"
                    type="datetime-local"
                    onChange={handleDateChange2}
                    // value={email}

                />
                
            </div>

            </div>

            <Table striped bordered hover id="policy-table">
            <thead>
                <tr>
                <th scope="col">#</th>
                <th scope="col">Policy Number</th>
                <th scope="col">Insured</th>     
                <th scope="col">Contact</th>
                <th scope="col">Registration</th>
                <th scope="col">Product</th>
                <th scope="col">Expiry Date</th>
                


                </tr>
            </thead>
            <tbody>
                {renewals.map((val, index) => {
                    if(start == '' && end == ''){
                        return (
                            <tr key={val.OID}>
                            <td>{index + 1}</td>
                            <td>{val.PolicyNo}</td>
                            <td>{val.Dealer_name}</td>  
                            <td>{val.Mobile}</td>
                            <td>{val.Narration}</td>
                            <td>{val.ProductDescription}</td>
                            <td>{formateDateISO(val.ExpiryDate)}</td>
                            </tr>
                        );

                    }
                    else if(start !== '' && end == ''){
                        return (
                            <tr key={val.OID}>
                            <td>{index + 1}</td>
                            <td>{val.PolicyNo}</td>
                            <td>{val.Dealer_name}</td>  
                            <td>{val.Mobile}</td>
                            <td>{val.Narration}</td>
                            <td>{val.ProductDescription}</td>
                            <td>{formateDateISO(val.ExpiryDate)}</td>
                            </tr>
                        );
                    }
                    else if(formatDateToMilliseconds(val.ExpiryDate) > start && formatDateToMilliseconds(val.ExpiryDate) < end ){
                        return (
                            <tr key={val.OID}>
                            <td>{index + 1}</td>
                            <td>{val.PolicyNo}</td>
                            <td>{val.Dealer_name}</td>  
                            <td>{val.Mobile}</td>
                            <td>{val.Narration}</td>
                            <td>{val.ProductDescription}</td>
                            <td>{formateDateISO(val.ExpiryDate)}</td>
                            </tr>
                        );
                    
                    }
                        

                })}
            </tbody>
            </Table>

            {/* Pagination controls */}
            <div className="d-flex justify-content-between align-items-center">
            <div>
                Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, renewals.length)} of {renewals.length} entries
            </div>
            <div>
                <button 
                className="btn btn-sm btn-outline-primary mx-1"
                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                >
                Previous
                </button>
                
                {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                <button
                    key={page}
                    className={`btn btn-sm mx-1 ${currentPage === page ? 'btn-primary' : 'btn-outline-primary'}`}
                    onClick={() => setCurrentPage(page)}
                >
                    {page}
                </button>
                ))}
                
                <button 
                className="btn btn-sm btn-outline-primary mx-1"
                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                disabled={currentPage === totalPages}
                >
                Next
                </button>
            </div>
            </div>
            </div>
            
        </CardBody>
    </Card>
    </div>
    </div>
  )
}
